"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function partitionByIndex(arr, index) {
    if (index >= 0) {
        return [arr.slice(0, index), arr.slice(index)];
    }
    else {
        return partitionByIndex(arr, arr.length + index);
    }
}
exports.partitionByIndex = partitionByIndex;
function distinct(arr) {
    return Array.from(new Set(arr));
}
exports.distinct = distinct;
exports.flatMap = function (arr, fn) { return Array.prototype.concat.apply([], arr.map(fn)); };
//# sourceMappingURL=arrayUtils.js.map


// WEBPACK FOOTER //
// ../../src/utils/arrayUtils.ts